const injectGTM = (gtmId: string) => {
  if (!gtmId || gtmId === '') {
    return;
  }

  // Inject the script part into the head
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${gtmId}');`;
  const firstHeadChild = document.head.firstChild;
  if (firstHeadChild) {
    document.head.insertBefore(script, firstHeadChild);
  } else {
    document.head.appendChild(script);
  }

  // Inject the noscript part into the body
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `
    <iframe
      src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0"
      width="0"
      style="display:none;visibility:hidden"
    />
  )`;
  const firstBodyChild = document.body.firstChild;
  if (firstBodyChild) {
    document.body.insertBefore(noscript, firstBodyChild);
  } else {
    document.body.appendChild(noscript);
  }
};

export default injectGTM;
